import { DIFFICULTY_LEVELS, YARN_WEIGHTS } from './patternOptions';

export const FILTER_OPTIONS = {
  difficulty_level: DIFFICULTY_LEVELS.map(level => level.value),
  yarn_weights: YARN_WEIGHTS,
  categories: ['Baby', 'Kids', 'Women', 'Men', 'Accessories']
};
